import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_POSITIONS_BEGIN](state) {
    state.positionsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_POSITIONS_SUCCESS](state, positions) {
    state.positionsGetError = null;
    state.positions = positions;
    state.positionsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_POSITIONS_ERROR](state, err) {
    state.positionsGetState = API_STATES.REQUEST_ERROR;
    state.positionsGetError = err;
  },
  [types.DELETE_POSITIONS_BEGIN](state) {
    state.positionDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_POSITIONS_SUCCESS](state, id) {
    state.positionDeleteError = null;
    state.positionDeleteState = API_STATES.REQUEST_SUCCESS;
    const index = findIndex(state.positions, function(o) {
      return o.id === id;
    });
    state.positions.splice(index, 1);
  },
  [types.DELETE_POSITIONS_ERROR](state, err) {
    state.positionDeleteState = API_STATES.REQUEST_ERROR;
    state.positionDeleteError = err;
  },

  [types.CREATE_POSITION_BEGIN](state) {
    state.positionCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_POSITION_SUCCESS](state, data) {
    state.positionCreateError = null
    state.positionCreateState = API_STATES.REQUEST_SUCCESS
    state.position=data
  },
  [types.CREATE_POSITION_ERROR](state, err) {
    state.positionCreateState = API_STATES.REQUEST_ERROR;
    state.positionCreateError = err;
  },
  [types.UPDATE_POSITION_BEGIN](state) {
    state.positionUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_POSITION_SUCCESS](state, data) {
    state.positionUpdateError = null
    state.position=data
    state.positionUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_POSITION_ERROR](state, err) {
    state.positionUpdateState = API_STATES.REQUEST_ERROR
    state.positionUpdateError = err
  },

  [types.ADD_USER_POSITION_BEGIN](state,userId) {
    state.userPositionUpdating.push(userId)
  },
  [types.ADD_USER_POSITION_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.userPositionUpdating, data.userId);
    state.userPositionUpdating.splice(index, 1);
    rootState.app.formData.userPositions.push(data)
    state.userPositionUpdateError = null
  },
  [types.ADD_USER_POSITION_ERROR](state, { err,userId }) {
    const index = findIndex(state.userPositionUpdating, userId);
    state.userPositionUpdating.splice(index, 1);
    state.userPositionUpdateError = err;
  },

  [types.DELETE_USER_POSITION_BEGIN](state, userId) {
    state.userPositionDeleting.push(userId);
  },
  [types.DELETE_USER_POSITION_SUCCESS](state, { userId, rootState }) {
    state.userPositionDeleteError = null;
    const index = findIndex(rootState.app.formData.userPositions, { userId });
    rootState.app.formData.userPositions.splice(index, 1)

    const index2 = findIndex(state.userPositionDeleting, userId);
    state.userPositionDeleting.splice(index2, 1);
  },
  [types.DELETE_USER_POSITION_ERROR](state, { err, userId }) {
    const index = findIndex(state.userPositionDeleting, userId);
    state.userPositionDeleting.splice(index, 1);
    state.userPositionDeleteError = err;
  }
};

export default mutations;
